export default {"src":"/_next/static/media/logo-blue.99d40b53.svg","height":45,"width":248,"blurWidth":0,"blurHeight":0};